import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349f894a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-info-wrapper" }
const _hoisted_2 = { class: "fare payment-info-row summary" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "dates payment-info-row summary" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "총 예약일", -1 /* HOISTED */))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "payment-info-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "총 결제금액", -1 /* HOISTED */))
const _hoisted_11 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.getOneTimeFareStr), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString($setup.useCurrencyFormat($props.oneTimeFare)) + "원", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", _hoisted_7, _toDisplayString($props.bookingDatesCount) + "일", 1 /* TEXT */)
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("p", _hoisted_11, _toDisplayString($setup.useCurrencyFormat($props.totalAmount)) + "원", 1 /* TEXT */)
    ])
  ]))
}